(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name ContactosService
     *@description
     *Listado de contactos con búsqueda, filtro por estado y paginación
     *(backend\controllers\ContactoController::actionListado())
     */

    angular
        .module('appback')
        .factory('ContactosService', ContactosService);

    ContactosService.$inject = ["$http", "$q"];

    function ContactosService($http, $q) {

        var service = {
            Listado: Listado,
        };

        /**
         * @param {Object} params q, estado (vacío = todos), page y pageSize.
         */
        function Listado(params) {
            return $http.get('/backend/contacto/listado', {
                params: params
            }).then(function (response) {
                if (!response.data || !response.data.success) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        return service;
    }
})();
